"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentBrandEnum = exports.FlattenViaPropEnum = exports.futureInstallmentStatuses = exports.failedInstallmentStatuses = exports.chargeableInstallmentStatuses = exports.scheduledChargeStatusWithTreansactionFee = exports.FuturePaymentStatusEnum = exports.SubPaymentMethodTypeEnum = exports.PaymentProcessorEnum = exports.PaymentMethodTypeEnum = exports.PaymentMethodsEnum = exports.PaymentStatusV1Enum = exports.ReasonTypeEnum = exports.PaymentFilterByEnum = exports.PaymentStatusEnum = void 0;
var PaymentStatusEnum;
(function (PaymentStatusEnum) {
    PaymentStatusEnum["NOT_PAID"] = "not_paid";
    PaymentStatusEnum["PARTIAL_PAYMENT"] = "partial";
    PaymentStatusEnum["FULLY_PAID"] = "paid";
    PaymentStatusEnum["REFUNDED"] = "refunded";
    PaymentStatusEnum["VOID"] = "void";
    PaymentStatusEnum["DISCOUNT"] = "discount";
    PaymentStatusEnum["REVERT_DISCOUNT"] = "revert_discount";
    PaymentStatusEnum["REVERT"] = "revert";
    PaymentStatusEnum["PENDING"] = "pending";
    PaymentStatusEnum["RETRY_IN_PROGRESS"] = "retry_in_progress";
})(PaymentStatusEnum = exports.PaymentStatusEnum || (exports.PaymentStatusEnum = {}));
var PaymentFilterByEnum;
(function (PaymentFilterByEnum) {
    PaymentFilterByEnum["PAYMENT_STATUS"] = "paymentStatus";
    PaymentFilterByEnum["STATUS"] = "status";
    PaymentFilterByEnum["ID"] = "id";
    PaymentFilterByEnum["CREATED_AT"] = "createdAt";
    PaymentFilterByEnum["PRICE"] = "price";
})(PaymentFilterByEnum = exports.PaymentFilterByEnum || (exports.PaymentFilterByEnum = {}));
var ReasonTypeEnum;
(function (ReasonTypeEnum) {
    ReasonTypeEnum["REFUND"] = "refund";
    ReasonTypeEnum["DISCOUNT"] = "discount";
    ReasonTypeEnum["PROMO_CODE"] = "promo_code";
    ReasonTypeEnum["MEMBERSHIP_PAUSE"] = "membership_pause";
})(ReasonTypeEnum = exports.ReasonTypeEnum || (exports.ReasonTypeEnum = {}));
var PaymentStatusV1Enum;
(function (PaymentStatusV1Enum) {
    PaymentStatusV1Enum[PaymentStatusV1Enum["SENT_TO_CLIENT"] = 1] = "SENT_TO_CLIENT";
    PaymentStatusV1Enum[PaymentStatusV1Enum["SENT_FOR_PAYMENT"] = 2] = "SENT_FOR_PAYMENT";
    PaymentStatusV1Enum[PaymentStatusV1Enum["ACCEPTED"] = 3] = "ACCEPTED";
    PaymentStatusV1Enum[PaymentStatusV1Enum["REJECTED"] = 4] = "REJECTED";
    PaymentStatusV1Enum[PaymentStatusV1Enum["CANCELLED"] = 5] = "CANCELLED";
    PaymentStatusV1Enum[PaymentStatusV1Enum["FRAUD"] = 6] = "FRAUD";
    PaymentStatusV1Enum[PaymentStatusV1Enum["NOT_RELEVANT"] = 7] = "NOT_RELEVANT";
    PaymentStatusV1Enum[PaymentStatusV1Enum["PENDING"] = 8] = "PENDING";
})(PaymentStatusV1Enum = exports.PaymentStatusV1Enum || (exports.PaymentStatusV1Enum = {}));
var PaymentMethodsEnum;
(function (PaymentMethodsEnum) {
    PaymentMethodsEnum[PaymentMethodsEnum["STRIPE"] = 1] = "STRIPE";
    PaymentMethodsEnum[PaymentMethodsEnum["CASH"] = 3] = "CASH";
})(PaymentMethodsEnum = exports.PaymentMethodsEnum || (exports.PaymentMethodsEnum = {}));
var PaymentMethodTypeEnum;
(function (PaymentMethodTypeEnum) {
    PaymentMethodTypeEnum["CARD"] = "card";
    PaymentMethodTypeEnum["ACH"] = "us_bank_account";
    PaymentMethodTypeEnum["CASH"] = "cash";
    PaymentMethodTypeEnum["CHECK"] = "check";
    PaymentMethodTypeEnum["BALANCE"] = "balance";
    PaymentMethodTypeEnum["CARD_ON_TERMINAL"] = "card-on-terminal";
    PaymentMethodTypeEnum["GIFT_CARD"] = "gift-card";
    PaymentMethodTypeEnum["OTHER"] = "other";
    PaymentMethodTypeEnum["MIGRATED"] = "migrated";
    PaymentMethodTypeEnum["LOST_DEBT"] = "lost-debt";
    PaymentMethodTypeEnum["VOID"] = "void";
    PaymentMethodTypeEnum["DISCOUNT"] = "discount";
    PaymentMethodTypeEnum["REVERT_DISCOUNT"] = "revert_discount";
})(PaymentMethodTypeEnum = exports.PaymentMethodTypeEnum || (exports.PaymentMethodTypeEnum = {}));
var PaymentProcessorEnum;
(function (PaymentProcessorEnum) {
    PaymentProcessorEnum["STRIPE"] = "stripe";
    PaymentProcessorEnum["OTHER"] = "other";
})(PaymentProcessorEnum = exports.PaymentProcessorEnum || (exports.PaymentProcessorEnum = {}));
var SubPaymentMethodTypeEnum;
(function (SubPaymentMethodTypeEnum) {
    SubPaymentMethodTypeEnum["CREDIT"] = "credit";
    SubPaymentMethodTypeEnum["DEBIT"] = "debit";
    SubPaymentMethodTypeEnum["PREPAID"] = "prepaid";
    SubPaymentMethodTypeEnum["UNKNOWN"] = "unknown";
})(SubPaymentMethodTypeEnum = exports.SubPaymentMethodTypeEnum || (exports.SubPaymentMethodTypeEnum = {}));
var FuturePaymentStatusEnum;
(function (FuturePaymentStatusEnum) {
    FuturePaymentStatusEnum["FUTURE"] = "future";
    FuturePaymentStatusEnum["SUCCEEDED"] = "succeeded";
    FuturePaymentStatusEnum["FAILED"] = "failed";
    FuturePaymentStatusEnum["CANCELED"] = "canceled";
    FuturePaymentStatusEnum["PENDING"] = "pending";
    FuturePaymentStatusEnum["RETRY_IN_PROGRESS"] = "retry_in_progress";
})(FuturePaymentStatusEnum = exports.FuturePaymentStatusEnum || (exports.FuturePaymentStatusEnum = {}));
exports.scheduledChargeStatusWithTreansactionFee = [
    FuturePaymentStatusEnum.FUTURE,
    FuturePaymentStatusEnum.PENDING,
    FuturePaymentStatusEnum.SUCCEEDED,
];
exports.chargeableInstallmentStatuses = [
    FuturePaymentStatusEnum.FUTURE,
    FuturePaymentStatusEnum.FAILED,
    FuturePaymentStatusEnum.RETRY_IN_PROGRESS,
];
/**
 * Array of failed installment statuses,
 * used for validation requested to make sure all failed installments paid.
 * This array includes the `FAILED` and `RETRY_IN_PROGRESS` statuses from the `FuturePaymentStatusEnum`.
 */
exports.failedInstallmentStatuses = [FuturePaymentStatusEnum.FAILED, FuturePaymentStatusEnum.RETRY_IN_PROGRESS];
/**
 * Array of future installment statuses.
 */
/**
 * Array of future installment statuses, includes statuses with future planned date.
 * This array includes the `FUTURE` and `RETRY_IN_PROGRESS` statuses from the `FuturePaymentStatusEnum`.
 */
exports.futureInstallmentStatuses = [FuturePaymentStatusEnum.FUTURE, FuturePaymentStatusEnum.RETRY_IN_PROGRESS];
var FlattenViaPropEnum;
(function (FlattenViaPropEnum) {
    FlattenViaPropEnum["CHILDREN"] = "children";
    FlattenViaPropEnum["TAX_ITEM"] = "taxLineItem";
})(FlattenViaPropEnum = exports.FlattenViaPropEnum || (exports.FlattenViaPropEnum = {}));
var PaymentBrandEnum;
(function (PaymentBrandEnum) {
    PaymentBrandEnum["VISA"] = "visa";
    PaymentBrandEnum["MASTERCARD"] = "mastercard";
    PaymentBrandEnum["INTERAC"] = "interac";
})(PaymentBrandEnum = exports.PaymentBrandEnum || (exports.PaymentBrandEnum = {}));
//# sourceMappingURL=payment.enums.js.map